const ExternalSvgMapper = {
    'logout': 'logoutIcon.svg',
    'card': 'cardIcon.svg',
    'computer': 'computerIcon.svg',
    'sell': 'sellIcon.svg',
    'cart': 'cartIcon.svg',
    'profile': 'profileIcon.svg',
    'bag': 'bagIcon.svg',
    'shield': 'shieldIcon.svg',
    'customerCare': 'customerCareIcon.svg',
    'star': 'starIcon.svg',
    'info': 'infoIcon.svg',
    'help': 'helpIcon.svg',
    'orderTracking': 'orderTrackingIcon.svg',
    'minus': 'minusIcon.svg',
    'plus': 'plusIcon.svg',
    'facebook': 'facebookIcon.svg',
    'youtube': 'youtubeIcon.svg',
    'instagram': 'instagramIcon.svg',
    'pinterest': 'pinterestIcon.svg',
    'twitter': 'twitterIcon.svg',
    'linkedin': 'linkedinIcon.svg',
    'playStore': 'playStoreIcon.svg',
    'appStore': 'appStoreIcon.svg',
    'mastercard': 'mastercardIcon.svg',
    'paypal': 'paypalIcon.svg',
    'oney': 'oneyLogo.svg',
    'klarna': 'klarna.svg',
    'visa': 'visaIcon.svg',
    'floa': 'floaLogo.svg',
    'americanexpress': 'americanExpress.svg',
    'creditCard': 'creditCardIcon.svg',
    'rakutenKoboLogo': 'rakutenKoboLogo.svg',
    'sliders': 'sliders.svg',
    'sort': 'sort.svg',
};

export { ExternalSvgMapper };
